import script from "./MallProductPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MallProductPage.vue?vue&type=script&setup=true&lang=ts"

import "./MallProductPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__